import React from "react";
import Layout from "../../components/layout";

const DeleteInvoice = () => {
  return <>DeleteInvoice</>;
};

export default DeleteInvoice;
